import { render, staticRenderFns } from "./rolemanagementpermissionlist.vue?vue&type=template&id=1f0d2112&scoped=true&"
import script from "./rolemanagementpermissionlist.vue?vue&type=script&lang=js&"
export * from "./rolemanagementpermissionlist.vue?vue&type=script&lang=js&"
import style0 from "./rolemanagementpermissionlist.vue?vue&type=style&index=0&id=1f0d2112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d2112",
  null
  
)

export default component.exports